<template>
    <bottom-sheet v-model="shows" title="미팅 생성하기" fullscreen persistent width="1224" maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <v-tabs-items v-model="tab" touchless class="h-100 scroll-primary pr-10" style="flex: 0 1 auto; overflow-y: auto; overflow-x: hidden">
                <tab-recruitment v-model="form.recruitment" v-on="{ prev, next }" />
                <tab-applications v-model="form.applications" :recruitment="form.recruitment" v-on="{ prev, next }" />
                <tab-schedules-available v-model="form" v-on="{ prev, next }" />
                <tab-confirm v-model="form" v-bind="{ loading }" v-on="{ prev, save }" />
                <tab-complete v-model="form" v-on="{ next, exit }" />
                <tab-texting v-model="form" v-on="{ exit }" />
            </v-tabs-items>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { initMeeting } from "@/assets/variables";

import TabConfirm from "./tab-confirm.vue";
import TabComplete from "./tab-complete.vue";
import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import TabRecruitment from "./tab-recruitment.vue";
import TabApplications from "./tab-applications.vue";
import TabSchedulesAvailable from "./tab-schedules-available.vue";
import TabTexting from "./tab-texting.vue";

export default {
    components: {
        TabConfirm,
        TabComplete,
        BottomSheet,
        TabRecruitment,
        TabApplications,
        TabSchedulesAvailable,
        TabTexting,
    },
    props: {
        value: { type: Object, default: initMeeting },
    },
    data: () => ({
        form: initMeeting(),

        tab: 0,
        shows: false,
        loading: false,
    }),
    watch: {
        shows() {
            if (this.shows) this.init();
            else if (this.form?._id) this.$emit("input", this.form);
        },
    },
    methods: {
        async init() {
            this.tab = 0;
            this.loading = false;
            this.form = initMeeting();
        },
        async save() {
            this.loading = true;
            try {
                let { recruitment, applications = [], ...form } = this.form;
                form._recruitment = recruitment?._id;
                form._applications = applications.map(({ _id }) => _id);
                let { meeting } = await api.v1.company.meetings.post(form);
                this.form = meeting;
                this.next();
            } finally {
                this.loading = false;
            }
        },

        prev() {
            this.tab -= 1;
        },
        next() {
            this.tab += 1;
        },
        exit() {
            this.shows = false;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .text-right input {
        text-align: right;
    }
    .v-input--switch label {
        margin-bottom: 4px;
    }
    .v-textarea textarea {
        margin: 0 !important;
        padding-top: 8px;
        line-height: 1.875em;
    }
}
</style>
